import { RenterDto } from '@tallo/renter';

import { RescheduleRequestStatus } from '../interfaces/reschedule-request.interface';
import { ShowingDto } from '../interfaces/showing.interface';

export function getReschedulingRenters(showing: ShowingDto): RenterDto[] {
  return showing.rescheduleRequests
    .filter(({ status }) => status === RescheduleRequestStatus.PENDING)
    .map(({ renter }) => renter);
}
